/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Repdirector3Inputs */

const ja_company_companydetails_repdirector3 = /** @type {(inputs: Company_Companydetails_Repdirector3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シタール マイケル - 代表取締役`)
};

const en_company_companydetails_repdirector3 = /** @type {(inputs: Company_Companydetails_Repdirector3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michael Sheetal - Representative Director`)
};

/**
* | output |
* | --- |
* | "Michael Sheetal - Representative Director" |
*
* @param {Company_Companydetails_Repdirector3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_repdirector3 = /** @type {((inputs?: Company_Companydetails_Repdirector3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Repdirector3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_repdirector3(inputs)
	return en_company_companydetails_repdirector3(inputs)
});
export { company_companydetails_repdirector3 as "company_companyDetails_RepDirector" }